import store from '@/store'
import { SetCasterStreamInfo } from '@/store/modules/events/events.actions'

const constructCasterStreamInfo = (): SetCasterStreamInfo|null => {
  const streamId = store.state.usermedia.streamDocId
  const type = store.state.events.castingAs
  const userId = store.getters.user.userProfile?.id
  const sessionId = store.state.user.sessionId
  if (!streamId || !type || !userId || !sessionId) return null
  return {
    streamId,
    type,
    userId,
    sessionId
  }
}

const useCasterStreamInfo = () => {
  return {
    constructCasterStreamInfo
  }
}

export default useCasterStreamInfo
